import React, {Component} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import apis from '../../helper/api'
import swal from 'sweetalert'

let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class ModalRealize extends Component {

    constructor(props) {
        // {agent_name, report_month, report_year, type, new_status}
        super(props)
        this.state = {
            flag_processing: false,
            remark_input: "",
            pajak_satuan_sel: "FIXED",
            pajak_input: ""
        }
    }

    componentDidMount() {
        let self = this
        util.log(this.props.data)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_select_change(e) {
        this.setState({[e.currentTarget.id] : e.currentTarget.value})
    }

    on_submit() {
        let data = this.props.data
        this.props.data.on_submit_realize(data.type, data.index, data.report_year, data.report_month, data.new_status, this.state.remark_input, this.state.pajak_satuan_sel, this.state.pajak_input)
        data.close()
    }

    render() {
        let self = this
    	let data = this.props.data
        
    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={false}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '500px',minHeight:'600px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            REALIZE {this.props.data.type.toUpperCase()}
	                        </h5>
	                    </div>
	                    <div className="modal-body" style={{padding: '15px 0'}}>
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">
                                        <div style={{margin: '10px 10px'}}>

                                            <div style={{marginBottom: '5px'}}>
                                                <span style={{fontWeight: '500'}} className="">
                                                    Remark / Info / Pesan
                                                </span>
                                            </div>
                                            <div style={{margin: 'auto 0'}}>
                                                <textarea style={{height:'80px'}} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" 
                                                    name="remark_input"
                                                    value={this.state.remark_input}/>
                                            </div>
                                            <div style={{marginBottom:'5px',marginTop:'10px'}}>
                                                <span style={{fontWeight: '500'}} className="">
                                                    Pajak
                                                </span>
                                            </div>
                                            <div style={{margin: 'auto 0'}} className="row">
                                                <input style={{width:'290px',marginRight:'10px'}} onChange={(e) => this.on_input_change(e)} className="form-control m-input" type="text" 
                                                    name="pajak_input"
                                                    value={this.state.pajak_input}/>
                                                <select id="pajak_satuan_sel" className="m-input" value={this.state.pajak_satuan_sel} onChange={(e) => this.on_select_change(e)} style={{width: '110px'}}>
                                                    <option value="FIXED">FIXED</option>
                                                    <option value="PERCENTAGE">PERCENTAGE</option>
                                                </select>
                                            </div>
                                            
                                            <div className="row" style={{textAlign:'center',fontWeight: 500,fontSize:'medium',marginBottom: '20px',marginTop:'200px',marginLeft:'20px',marginRight: '20px'}}>
                                                Apakah Anda yakin untuk realize {data.type} {data.agent_name} bulan {data.report_month} tahun {data.report_year} pada {data.new_status} ?
                                            </div>

                                            <div className="row" style={{marginTop:'20px',textAlign:'center',display:'block'}}>
                                                <button onClick={(e) => this.props.data.close(e)} className="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--bolder" style={{fontSize:'small',paddingTop:'7px',paddingBottom:'7px'}}>Batal</button>  
                                                <button onClick={(e) => this.on_submit(e)} className={this.state.flag_processing ? 'btn m-btn--pill btn-secondary m-btn m-btn--custom  m-btn--bolder m-loader m-loader--primary m-loader--right' : 'btn m-btn--pill btn-primary m-btn m-btn--custom  m-btn--bolder'} style={{fontSize: 'small',paddingTop:'7px',paddingBottom:'7px'}}>Submit</button>
                                            </div> 
                                        </div>
			                        </div>
			                    </div>
				            </div>
	                    </div>
	                    <div className="modal-footer" style={{borderTop: 0, display:'none'}}>
	                    </div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalRealize)



// WEBPACK FOOTER //
// ./src/component/form/dialog_realize.js